<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import Flickity from "flickity-fade";
import { get } from "lodash";
import TileCarouselFullscreen from "tile-carousel-fullscreen"

export default {
  mixins: [fandomBasicMixin],
  components: {
    TileCarouselFullscreen
  },
  data() {
    return {
      currentSlide: null
    };
  },
  computed: {
    miniformatTitle() {
      return get(this.containerContent, ["decorators", "miniformat"], null);
    },
    isViewportSmall() {
      return globalState.viewport.sm || globalState.viewport.xs;
    },
    perPage() {
      return this.content.per_page ? parseInt(this.content.per_page) : 1;
    }
  },
  methods: {
    scrollToBottom: Fandom.scrollToBottom,
    getContentURL: Fandom.getContentURL,
    getContentURLByContentName(contentName) {
      return Fandom.getContentURL(Fandom.getContent(contentName));
    },
    autoPlaySelectedSlide(slider) {
      for (const video of slider.selectedElement.querySelectorAll("video")) {
        video.muted = true; // Muted attribute seems to not be parsed correctly by vue.
        video.play();
      }
    },
  },
  mounted() {  
    Vue.nextTick(() => {
      const config = {
        draggable: ">1",
        prevNextButtons: true,
        arrowShape: "M47.89,1,.78,48.11a2.68,2.68,0,0,0,0,3.78L47.89,99a2.67,2.67,0,0,0,3.79,0l1.58-1.57a2.67,2.67,0,0,0,0-3.79L13.42,53.79h83.9A2.67,2.67,0,0,0,100,51.12V48.88a2.67,2.67,0,0,0-2.68-2.67H13.42L53.26,6.36a2.67,2.67,0,0,0,0-3.79L51.68,1A2.67,2.67,0,0,0,47.89,1Z",
        wrapAround: true,
        pageDots: ">1",
        contain: true,
        cellAlign: 'left',
        groupCells: this.content.per_page,
        autoPlay: true,
        autoPlay: 5000 // 5s
      }

      const slider = new Flickity(this.$refs["flickity-carousel"], config);

      slider.on("select", () => {
        for (const video of this.currentSlide.querySelectorAll("video")) {
          video.pause();
        };
        this.autoPlaySelectedSlide(slider);
        this.currentSlide = slider.selectedElement;

        const animateBg = $(this.currentSlide).find(".inview_animate_zoom");
        animateBg.removeClass("inview_animate_zoom_in").addClass("inview_animate_zoom_in"); // restart animation
      });

      slider.on("resize", () => {
        $(this.$refs["flickity-carousel"]).toggleClass('is-single-slide', (slider.slides.length < 2));
      });
      $(this.$refs["flickity-carousel"]).toggleClass('is-single-slide', (slider.slides.length < 2));

      this.currentSlide = slider.selectedElement;
      this.autoPlaySelectedSlide(slider);

      this.registerAnimation();
    });
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="inview_animate" :id="content.name" stripe-carousel-fullscreen-component>
    <div class="flickity-carousel" ref="flickity-carousel">
      <div class="flickity-carousel-item h-100vh-header w-100" v-for="(item, index) in content.children" :child_name="item" :key="`carousel-slide-${index}`">
        <a :href="getContentURL(getContent(item))" class="deco-none">
          <tile-carousel-fullscreen 
            :miniformatTitle="miniformatTitle" 
            :content="getContent(item)" 
            class="h-100vh-header"
            :animation="true"
          ></tile-carousel-fullscreen>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-carousel-fullscreen-component] {
  position: relative;

  .slide-icon {
    width: 14rem !important;
    max-width: none !important;
  }

  .flickity-prev-next-button {
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      position: relative;
      width: 45%;
      height: 45%;
      left: 0;
      top: 0;
    }
  }

  .flickity-carousel-item:not(.is-selected) .inview_animate_zoom_in {
    animation-name: none !important;
  }

  .is-single-slide .flickity-page-dots {
    display: none;
  }

  @include media-breakpoint-down(sm) {
    .per-page-3,
    .per-page-2 {
      width: 100vw;
    }
  }

  .flickity-carousel {
    position: relative;
    color: $white;
    background-color: $black;
  }

  .flickity-page-dots {
    bottom: 4rem;
    .dot {
      background-color: $white;
      border: 1px solid $white;
    }
  }

  @include media-breakpoint-down(xs) {
    .flickity-prev-next-button,
    .flickity-prev-next-button,
    .flickity-viewport::after,
    .flickity-viewport::before {
      display: none;
    }
  }
}
</style>
